<template>
  <div
    :class="[
      'mt-3 mt-md-auto mx-auto w-100 border p-3 p-md-4',
      { 'text-right rtl': $i18n.locale !== 'en' },
    ]"
    style="max-width: 400px"
  >
    <h1 class="mb-4 text-center" style="color:#555">
      <span class="form-header">{{ $t("reset_password") }}</span>
    </h1>
    <p class="text-center my-4">
      {{ $t("reset_password_desc") }}
    </p>
    <form method="post" ref="form">
      <field-input
        v-model="emailOrMobile"
        ref="email_or_mobile"
        type="text"
        :name="fieldName"
        :label="$t('email_or_mobile')"
        :server-error="serverError.email_or_mobile"
        number
        :rules="[
          vRules.required($t('validation_message.email_or_mobile_is_required')),
          vRules.email_or_phone(),
        ]"
        data-gtm-name="login_password_recovery_email_phone"
      />

      <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />
      <div
        v-if="serverError.nonFieldErrors"
        class="mt-0 error-text text-center mb-4"
      >
        {{ serverError.nonFieldErrors }}
      </div>

      <div class="d-flex w-100 mt-3 justify-content-end">
        <button
          class="btn btn-primary rounded-0"
          type="submit"
          data-gtm-name="login_password_recovery_search_account"
        >
          {{ $t("search_account") }}
        </button>
      </div>
      <div v-if="!userIsAuthenticated" class="d-flex w-100 mt-4">
        <a
          :href="urls.login"
          class="link my-auto"
          data-gtm-name="login_password_recovery_enter_account"
          >{{ $t("login_to_account") }}</a
        >
      </div>
    </form>
  </div>
</template>

<script>
import FieldInput from "~/components/FieldInput.vue";

export default {
  components: { FieldInput },
  data: () => ({ ...serverData }),
  mounted() {
    this.$refs.email_or_mobile.focus();
    this.$refs.form.addEventListener("submit", (e) => {
      if (!this.$refs.email_or_mobile.validate()) {
        e.preventDefault();
      } else {
        if (/^9\d{9}$/.test(this.emailOrMobile)) {
          this.emailOrMobile = "0" + this.emailOrMobile;
        } else if (/^\+989\d{9}$/.test(this.emailOrMobile)) {
          this.emailOrMobile = this.emailOrMobile.replace("+98", "0");
        } else if (
          /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(
            this.emailOrMobile
          )
        ) {
          this.emailOrMobile = this.emailOrMobile.toLowerCase();
        }
      }
    });
  },
};
</script>
